import { Subject } from "rxjs";
import { Http } from "./http";
import { RTC } from "./rtc";
import { WebSocket } from "./websocket";

export const createWebNetwork = (fetch: typeof window.fetch, windowWebsocket: typeof window.WebSocket) => {
  
  return {
    createHTTPClient(): Http.Client {
      return {
        async request(url, options) {
          
          const request = new Request(url, {
            body: options.body && await new Response(options.body).blob(),
            headers: options.headers,
            method: options.method
          })

          const response = await fetch(request);

          return {
            status: response.status,
            headers: Object.fromEntries(response.headers.entries()),
            body: response.body
          }
        },
      }
    },

    createWSClient(): WebSocket.Client {
      return {
        connect(url, protocols) {
          const socket = new windowWebsocket(url.href, protocols)
          const receive = new Subject<string | ArrayBuffer>();

          socket.addEventListener('message', message => {
            receive.next(message.data);
          })

          return {
            port: {
              send(message) {
                socket.send(message)
              },
              receive,
            },
            disconnect() {
              socket.close();
            },
            ready: new Promise(r => {
              function onOpen() {
                r({ protocol: socket.protocol });
                socket.removeEventListener('open', onOpen);
              }
              socket.addEventListener('open', onOpen)
            }),
            disconnected: new Promise(r => {
              function onClose(event: CloseEvent) {
                r({ reason: event.code });
                socket.removeEventListener('close', onClose);
              }
              socket.addEventListener('close', onClose)
            })
          }
        },
      }
    },
  }
};

export type NetworkClient = {
  rtc: RTC.Client,
  http: Http.Client,
  ws: WebSocket.Client,
};
